import { createFileRoute } from "@tanstack/react-router";
import { RequiredAttachmentsField } from "@/features/attachment-requirements/required-attachments-field";
import { EntityTypeDetailsPanel } from "@/features/entity-types/components/entity-type-details-panel";
import { RequiredLocationField } from "@/features/entity-types/components/required-location-field";
import { useAppTranslation } from "@/hooks/use-app-translation";
import { useJobTypeDrawerContext } from "@/utils/job-type-detail/job-type-drawer-context";
import { resolveJobTypeDisplayIcon } from "@/utils/jobs";

export const Route = createFileRoute(
	"/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/configuration/jobTypes/$jobTypeId/details",
)({
	component: OrgJobTypeDetailsTab,
});

function OrgJobTypeDetailsTab() {
	const { t } = useAppTranslation();
	const {
		jobType,
		canEdit,
		persistDetails,
		locationRequired,
		persistLocationRequired,
	} = useJobTypeDrawerContext();

	const sourceLabel = jobType.defaultType
		? t("admin.jobTypes.table.source.system")
		: t("admin.jobTypes.table.source.custom");

	return (
		<EntityTypeDetailsPanel
			labels={{
				name: t("admin.jobTypes.drawer.details.fields.name"),
				icon: t("admin.jobTypes.drawer.details.fields.icon"),
				source: t("admin.jobTypes.drawer.details.fields.source"),
				lifecycle: t("admin.jobTypes.drawer.details.fields.lifecycle"),
				id: t("admin.jobTypes.drawer.details.fields.id"),
				description: t("admin.jobTypes.drawer.details.fields.description"),
				nameRequired: t("admin.entityTypes.drawer.details.nameRequired"),
				saveFailed: t("admin.entityTypes.drawer.details.saveFailed"),
			}}
			name={jobType.name}
			icon={jobType.icon}
			description={jobType.description}
			sourceLabel={sourceLabel}
			lifecycleLabel={jobType.lifecycleName}
			showLifecycle
			id={jobType.id}
			resolveIcon={(icon) => resolveJobTypeDisplayIcon(icon, jobType.name)}
			iconEditable
			locationRequiredField={
				<RequiredLocationField
					value={locationRequired}
					canEdit={canEdit}
					onChange={persistLocationRequired}
				/>
			}
			attachmentsField={
				<RequiredAttachmentsField
					entityKind="job"
					typeId={jobType.id}
					requirement={jobType.attachmentRequirement}
				/>
			}
			canEdit={canEdit}
			onPersist={persistDetails}
			data-testid="jobtype-details-panel"
		/>
	);
}
